export const it = {
  paper: {
    pagination: "Pagina {current} di {count}",
    printedOn: "Stampato il {date} alle {time}",
  },
};
